import React from 'react';
import PropTypes from 'prop-types';

import Headline from '@components/atoms/headline/headline';

import StyledWishRadio from './wishRadio.style';

const WishRadio = ({ label, name, value, onChange, required = false }) => (
  <StyledWishRadio>
    <input
      type="radio"
      id={label}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
    />
    <label htmlFor={label}>
      <Headline tag="span" subline>
        {label}
      </Headline>
    </label>
  </StyledWishRadio>
);

WishRadio.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool
};

export default WishRadio;
